import * as angular from 'angular';
import { SeatsMapTransformer } from '../transformer/ib-seat-map-transformer';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';
import { AncCallSeatsMapService } from '../../../../features/services/sea-cism/services/ib-call-seats-map-service';
import { AncGetCachedInformationService } from '../../../../features/services/pac-prm/services/ib-get-cached-information-service';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { CommonsAncillariesService } from 'ib-web-commons/dist/app/core/http-services/ass-fass/ib-commons-ancillaries-service';
export class SeatsMapService {
    constructor (
        private AncCallSeatsMapService: AncCallSeatsMapService,
        private SeatsMapTransformer: SeatsMapTransformer,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $q: ng.IQService,
        private ModalServiceAncillaries: any,
        private AncGetCachedInformationService: AncGetCachedInformationService,
        private $location: ng.ILocationService,
        private AncillariesUtilsService: AncillariesUtilsService,
        private AncillariesConstants: AncillariesConstant,
        private CommonsModalService: CommonsModalService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private DatalayerUtils: DatalayerUtils,
        private CommonsAncillariesService: CommonsAncillariesService) {
    }
    ////////////////
    searchSeatsMap = (): any => {
        const deferred = this.$q.defer();
        let seatsInfo;
        const segment: any = this.localStorageService.get('seatMapSegment');
        const searchSeatsMapSuccess = (seatsData: any): any => {
            const cachedInfo = this.localStorageService.get('bookingInfo');
            seatsInfo = seatsData;
            this.localStorageService.set('seatMap', seatsData);
            if (cachedInfo !== null) {
                cachedInformationSuccess(cachedInfo);
            } else {
                this.AncGetCachedInformationService.getCachedInformation().then(cachedInformationSuccess, searchSeatsMapError);
            }
        };

        const cachedInformationSuccess = (cachedData: any): any => {
            const transformedData = this.SeatsMapTransformer.generateSeatsMapRequest(seatsInfo, this.localStorageService.get('seatMapSegment'), cachedData);
            deferred.resolve(transformedData);
        };

        const searchSeatsMapError = (error: any): any => {
            deferred.reject(error);
            this.ModalServiceAncillaries.isNotWaiting();
            this.ModalServiceAncillaries.setErrorMessage(error.message);
            this.ModalServiceAncillaries.setErrorCode(error.internalErrorCode);
            this.ModalServiceAncillaries.setErrorGetOut(this.localStorageService.get('earlyCheckinCode'));
            this.CommonsModalService.showGenericError(error, null, null).result.then(angular.noop, angular.noop);
        };

        this.AncCallSeatsMapService.getSeatsMap(segment.segmentId).then(searchSeatsMapSuccess, searchSeatsMapError);
        return deferred.promise;
    };

    /**
     * Send information of seat map
     * Aqui se envía los datos del asiento
     * @param {*} updateSeatsInfo
     * @param {*} currency
     */
    updatePassengersSeats = (updateSeatsInfo: any, currency: any): any => {
        const deferred = this.$q.defer();
        let update = {};
        const updatePassengersSeatsSuccess = (data: any): any => {
            const segment: any = this.localStorageService.get('seatMapSegment');
            // let aviosReq = <AncillariesModel.AviosAncillaries[]>[];
            // aviosReq = this.SeatsMapTransformer.genAviosSeatReq();
            // this.localStorageService.set('genAviosAncillariesSeat', aviosReq);
            if (this.AncillariesUtilsService.isCheckinFlow()) {
                this.AncillariesUtilsService.updateCachedCheckinInformation(update, segment.segmentId);
                this.SeatsMapTransformer.updateSeatCheckinInformation(updateSeatsInfo);
                this.SeatsMapTransformer.updateAncillariesInformation(updateSeatsInfo, segment.segmentId);
            } else {
                this.AncillariesUtilsService.updateSeatCachedInformation(update, segment.segmentId);
                this.SeatsMapTransformer.updateSeatInformation(updateSeatsInfo);
            }

            deferred.resolve(data);

        };

        const updatePassengersSeatsError = (error: any): void => {
            deferred.reject(error);
        };
        if (updateSeatsInfo.length > 0) {
            if (this.localStorageService.get('currency') === null) {
                this.localStorageService.set('currency', currency);
            }
            update = this.AncillariesUtilsService.generateUpdateSeatsMap(updateSeatsInfo);
            this.CommonsAncillariesService.updateAncillaries(update).then(updatePassengersSeatsSuccess, updatePassengersSeatsError);
        } else {
            deferred.resolve();
        }
        return deferred.promise;


    };

    /**
     * Redirect to ancillaries page
     */
    cancelSeatMap = (): void => {
        this.$location.path(this.AncillariesConstants.PAGES_ROUTES.ANCILLARIES_PAGE);
    };

    /**
     * Check if segment is the first of all
     */
    isFirstSegment = (): any => {
        return this.SeatsMapTransformer.isFirstSegment();
    };
}



SeatsMapService.$inject = ['AncCallSeatsMapService', 'SeatsMapTransformer', 'localStorageService', '$q', 'ModalServiceAncillaries', 'AncGetCachedInformationService', '$location', 'AncillariesUtilsService', 'AncillariesConstants', 'CommonsModalService', 'DatalayerUtilsService', 'DatalayerUtils', 'CommonsAncillariesService'];
try {
    const mod = angular.module('ib-seat-map-module');
    mod.service(
        'SeatsMapService',
        SeatsMapService
    );
} catch (error) {
    const mod = angular.module('ib-seat-map-module', []);
    mod.service(
        'SeatsMapService',
        SeatsMapService
    );
}